import React from 'react';
import toast from 'react-hot-toast';
import Modal from '../shared/Modal';
import { Dumbbell, Printer, Mail } from 'lucide-react';
import logo from '../../assets/images/logo.jpg'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import api from '../../services/ApiService';
import { ENDPOINTS } from '../../constant/ApiEndpoints';

const ReceiptModal = ({ isOpen, onClose, payment }) => {
    if (!payment) return null;

    const handlePrint = () => {
        toast.success('Printing receipt...');
        printDiv();
    };
    function printDiv() {
        const printContents = document.getElementById("receipt-content").innerHTML;
        const originalContents = document.body.innerHTML;

        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;

        // reload scripts & styles if needed
        window.location.reload();
    }

    async function generatePdfBlob() {
        const element = document.getElementById("receipt-content");

        const canvas = await html2canvas(element, { scale: 2 });
        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 210; // A4 width
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

        return pdf.output("blob");   // RETURN AS BLOB
    }

    const handleEmail = async () => {
        try {
            const pdfBlob = await generatePdfBlob();
            const formData = new FormData();

            // your backend expects an ARRAY of files → "files"
            formData.append("file", pdfBlob, "receipt.pdf");            
            
            formData.append("to", payment?.user?.email);
            formData.append("subject", "Payment Bill");
            formData.append("body", "Please find the attached payment receipt.");

            // send to your email API
            let response = await api.post(
                ENDPOINTS.sendPdfApi,
                formData
            );
            toast.success(`The receipt has been successfully sent to ${payment?.user?.email}.`);
            console.log("Email sent:", response.data);
            console.log("Email sent:", response.data);

        } catch (error) {
            console.error("PDF Send Error:", error);
        }
    };


    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Payment Receipt">
            <div className="space-y-4">
                <div id="receipt-content" className="p-6 bg-gray-50 rounded-lg border border-dashed border-gray-300">
                    <div className="flex justify-between items-center pb-4 border-b border-dashed">
                        <div className="flex items-center gap-2">
                            <div className="flex items-center gap-3 mb-6">
                                <img src={logo} alt="Logo" width={150} />
                            </div>
                        </div>
                        <div className="text-right">
                            <p className="font-bold text-lg">Receipt</p>
                            <p className="text-xs text-gray-500">#{payment.id}</p>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4 mt-4 text-sm">
                        <div>
                            <p className="text-gray-500">Billed To</p>
                            <p className="font-semibold text-gray-800">{payment?.user?.name}</p>
                        </div>
                        <div className="text-right">
                            <p className="text-gray-500">Date</p>
                            <p className="font-semibold text-gray-800">{new Date(payment.payment_date).toLocaleDateString()}</p>
                        </div>
                    </div>
                    <table className="w-full mt-6 text-sm">
                        <thead>
                            <tr className="border-b border-dashed">
                                <th className="text-left font-semibold py-2">Description</th>
                                <th className="text-right font-semibold py-2">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="py-2">{payment?.plan?.name} Membership</td>
                                <td className="text-right py-2">{payment.amount.toFixed(3)} OMR</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr className="border-t-2 border-dashed font-bold">
                                <td className="text-right py-2">Total Paid</td>
                                <td className="text-right py-2">{payment.amount.toFixed(3)} OMR</td>
                            </tr>
                        </tfoot>
                    </table>
                    <div className="mt-4 text-sm">
                        <p><span className="font-semibold">Method:</span> {payment.payment_method}</p>
                        {payment.transactionId && <p><span className="font-semibold">Transaction ID:</span> {payment.transactionId}</p>}
                    </div>
                    <p className="text-center text-xs text-gray-500 mt-6">Thank you for your payment!</p>
                </div>
                <div className="pt-4 flex justify-end gap-3">
                    <button onClick={handleEmail} className="flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600">
                        <Mail size={18} /> Email Receipt
                    </button>
                    <button onClick={handlePrint} className="flex items-center gap-2 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700">
                        <Printer size={18} /> Print
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ReceiptModal;
